import { TicketStepProps } from '../blocks/VivaBuyTickets';
import { Flow, FlowToSanityTicketSlug } from '../services/viva/constants';

import type { TicketType } from '../services/viva/types';
import type { Block } from '@sanity/block-content-to-react';

export const prepareTicketStepData = ({
  flow,
  data,
  tickets,
}: {
  flow: Flow;
  data: Queries.BuyTicketsTorQuery;
  // TODO : Bring back with other flows
  // | Queries.BuyTicketsExpressPassQuery
  // | Queries.BuyTicketsVipQuery;
  tickets: TicketType[];
}): TicketStepProps => {
  const slug = FlowToSanityTicketSlug[flow];
  const rawWhatsIncluded = data.allSanityTicketCategory?.nodes?.flatMap(
    (category) =>
      category?.tickets?.filter((ticket) => ticket?.slugId === slug),
  )[0]?._rawWhatsIncluded as Block[] | undefined;

  return {
    title: data?.page?.ticketStep?.title ?? '',
    description: data?.page?.ticketStep?.description ?? '',
    ticketTypes: tickets,
    whatsIncluded: rawWhatsIncluded
      ? {
          children: rawWhatsIncluded.map((block) => ({
            _key: block._key,
            whatsIncludedText: block.children?.[0]?.text || '',
            style: block.style,
            level: block.level,
            listItem: block.listItem,
            marks: block.children?.[0]?.marks || [],
            markDefs: block.markDefs || [],
          })),
        }
      : undefined,
  };
};
